"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacilitiesLegend = FacilitiesLegend;
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _List2 = _interopRequireDefault(require("@mui/material/List"));
var _ListItem2 = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemText2 = _interopRequireDefault(require("@mui/material/ListItemText"));
var _ListItemIcon2 = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _services = require("../../services");
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const items = [{
  key: 'dedicatedRoads',
  Icon: _icons.DedicatedRoadsLegendIcon,
  labelKey: 'commons.facilities_legend.dedicated_roads',
  descriptionKey: 'commons.facilities_legend.dedicated_roads_description'
}, {
  key: 'opposites',
  Icon: _icons.OppositesLegendIcon,
  labelKey: 'commons.facilities_legend.opposites'
}, {
  key: 'sharedRoads',
  Icon: _icons.SharedRoadsLegendIcon,
  labelKey: 'commons.facilities_legend.shared_roads',
  descriptionKey: 'commons.facilities_legend.shared_roads_description'
}, {
  key: 'trafficCalmingZones',
  Icon: _icons.TrafficCalmingZonesLegendIcon,
  labelKey: 'commons.facilities_legend.traffic_calming_zones',
  descriptionKey: 'commons.facilities_legend.traffic_calming_zones_description'
}, {
  key: 'temporaryFacilities',
  Icon: _icons.TemporaryFacilitiesLegendIcon,
  labelKey: 'commons.facilities_legend.temporary_facilities'
}, {
  key: 'exclusionZones',
  Icon: _icons.ExclusionZonesLegendIcon,
  labelKey: 'commons.facilities_legend.exclusion_zones',
  descriptionKey: 'commons.facilities_legend.exclusion_zones_description'
}, {
  key: 'mainRoutes',
  Icon: _icons.MainRoutesLegendIcon,
  labelKey: 'commons.facilities_legend.main_routes',
  descriptionKey: 'commons.facilities_legend.main_routes_description'
}];
function FacilitiesLegend({
  row,
  selectedFacilities,
  enableDescriptions,
  layers
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enableTmpFacilities
  } = _services.AppService.environment;
  return /*#__PURE__*/_react.default.createElement(_List2.default, {
    dense: true,
    sx: {
      display: 'flex',
      flexDirection: row ? 'row' : 'column',
      flexWrap: row ? 'wrap' : undefined,
      columnGap: 2,
      rowGap: row ? 1 : 2,
      padding: 0,
      width: '100%',
      li: {
        padding: 0,
        width: row ? 'auto' : '100%'
      }
    }
  }, layers && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, layers.map(({
    id,
    name,
    LegendIcon
  }) => /*#__PURE__*/_react.default.createElement(_ListItem2.default, {
    key: id
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon2.default, null, LegendIcon && /*#__PURE__*/_react.default.createElement(LegendIcon, null)), /*#__PURE__*/_react.default.createElement(_ListItemText2.default, {
    primary: name,
    slotProps: {
      primary: {
        fontWeight: 600
      }
    },
    sx: {
      margin: 0
    }
  }))), /*#__PURE__*/_react.default.createElement(StyledDivider, null)), items.filter(({
    key
  }) => (enableTmpFacilities || key !== 'temporaryFacilities') && (!selectedFacilities || key === 'dedicatedRoads' && (selectedFacilities.includes('cycleway') || selectedFacilities.includes('greenway')) || key === 'sharedRoads' && (selectedFacilities.includes('lane') || selectedFacilities.includes('sharebusway')) || key === 'opposites' && selectedFacilities.includes('opposite') || key === 'trafficCalmingZones' && selectedFacilities.includes('mixedfacilities'))).map(({
    key,
    Icon,
    labelKey,
    descriptionKey
  }) => /*#__PURE__*/_react.default.createElement(_ListItem2.default, {
    key: key
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon2.default, {
    sx: row ? {
      minWidth: 40
    } : {
      alignSelf: 'flex-start'
    }
  }, /*#__PURE__*/_react.default.createElement(Icon, null)), /*#__PURE__*/_react.default.createElement(_ListItemText2.default, {
    primary: t(labelKey, {
      context: row ? 'short' : ''
    }),
    secondary: enableDescriptions && descriptionKey && t(descriptionKey),
    slotProps: {
      primary: row ? {} : {
        fontWeight: 600
      },
      secondary: {
        color: 'inherit',
        marginTop: 0.5,
        variant: 'body2'
      }
    },
    sx: {
      margin: 0
    }
  }))));
}
const StyledDivider = (0, _styledComponents.styled)(_Divider2.default)`
  && {
    margin: 8px 0;
  }
`;